import { clamp01 } from './cameraPath';

/** Scroll length of the journey, in viewport heights. */
export const JOURNEY_SCROLL_VH = 640;

export function progressFromOffsets(scrolled: number, total: number): number {
  if (!Number.isFinite(scrolled) || !Number.isFinite(total) || total <= 0) return 0;
  return clamp01(scrolled / total);
}

export function elementCanScroll(scrollHeight: number, clientHeight: number): boolean {
  return scrollHeight > clientHeight + 1;
}

/** Progress when this element is itself the scroller. Null when it cannot scroll. */
export function selfScrollProgress(scrollTop: number, scrollHeight: number, clientHeight: number): number | null {
  if (!elementCanScroll(scrollHeight, clientHeight)) return null;
  return progressFromOffsets(scrollTop, scrollHeight - clientHeight);
}

/**
 * The wizard live-preview card uses overflow-hidden, which breaks viewport
 * sticky. That embed scrolls inside itself instead of stretching the page.
 */
export function isEmbeddedPreview(start: HTMLElement | null): boolean {
  let node = start?.parentElement ?? null;
  while (node) {
    const cls = node.getAttribute('class') ?? '';
    if (cls.includes('overflow-hidden') && cls.includes('rounded-3xl')) return true;
    node = node.parentElement;
  }
  return false;
}

export function findScrollParent(
  start: HTMLElement | null,
  overflowY: (el: HTMLElement) => string,
): HTMLElement | null {
  let node = start?.parentElement ?? null;
  while (node) {
    const oy = overflowY(node);
    const canScroll = oy === 'auto' || oy === 'scroll' || oy === 'overlay';
    if (canScroll && node.scrollHeight > node.clientHeight + 1) return node;
    node = node.parentElement;
  }
  return null;
}

/** How far `root` has travelled through its scroll parent, in pixels. */
export function scrolledWithinParent(rootTop: number, parentTop: number): number {
  return parentTop - rootTop;
}
